import React, { useEffect } from "react";

import Main from '../components/Fees/Main'
import Switcher from "../components/Fees/Switcher";
import SimpleSteps from "../components/Home/SimpleSteps";

function Fees () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#E6E3E6]">
            <Main/>
            <Switcher/>
            <SimpleSteps/>
        </div>
    );
}

export default Fees;